import DefaultMapper from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

const splitIds = id => {
	// Only consider first underscore, other underscores are part of the parameter name.
	const idx = id.indexOf('_');
	return [id.substring(0, idx), id.substring(idx + 1)];
};

class BusinessContractParameterMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'payment/businesscontracts';
	}

	prepareGetOne({ params, options, mappedResource }) {
		const ids = splitIds(params.id);
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${ids[0]}`;
	}

	finishGetOne({ type, resource, params, options, mappedResource, result }) {
		const ids = splitIds(params.id);
		const parameter = result.data.parameters[ids[1]];
		return {
			data: {
				id: params.id,
				businessContractId: ids[0],
				...parameter
			}
		};
	}

	prepareUpdate({ type, resource, params, options, mappedResource }) {
		const ids = splitIds(params.data.id);
		options.method = 'POST';
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${ids[0]}/parameters`;
		options.body = JSON.stringify({
			name: ids[1],
			value: params.data.value,
			secure: params.data.secure
		});
	}
	finishUpdate({ type, resource, params, options, mappedResource, result }) {
		return {
			data: {
				id: params.data.id,
				...result.data
			}
		};
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.filter.id}`;
	}
	finishGetList({ type, resource, params, options, mappedResource, result }) {
		const { parameters } = result.data;
		const data = Object.keys(parameters)
			.sort()
			.map(key => {
				return {
					id: `${params.filter.id}_${key}`,
					name: key,
					value: parameters[key].value,
					secure: parameters[key].secure
				};
			});
		return {
			data: data,
			total: data.length
		};
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}/parameters`;
		options.method = 'POST';
		options.body = JSON.stringify(params.data);
	}

	prepareDeleteMany({ type, resource, params, options, mappedResource }) {
		const businessContractId = splitIds(params.ids[0])[0];
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${businessContractId}/parameters/{id}`;
		options.method = 'DELETE';
		options._ids = params.ids.map(id => splitIds(id)[1]);
	}
}

export default BusinessContractParameterMapper;
